module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Key":"Eindeutige Kennung","Name":"Name","Color":"Farbe","Description":"Beschreibung"}}')
  delete Component.options._Ctor
}
